import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {SnotifyModule, SnotifyService, ToastDefaults} from 'ng-snotify';
import {ContainerComponent} from './view/common/container/container.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

//common component
import {HeaderComponent} from './view/common/header/header.component';
import {FooterComponent} from './view/common/footer/footer.component';
import {NavigationComponent} from './view/common/navigation/navigation.component';

//master file component
import {MGiftVoucherComponent} from './view/master-files/m-gift-voucher/m-gift-voucher.component';
import {MGiftVoucherPriceCategoryComponent} from './view/master-files/m-gift-voucher-price-category/m-gift-voucher-price-category.component';
import {MGiftVoucherBulkCustomerComponent} from './view/master-files/m-gift-voucher-bulk-customer/m-gift-voucher-bulk-customer.component';
import {TGiftVoucherTransferComponent} from './view/transactions/t-gift-voucher-transfer/t-gift-voucher-transfer.component';

//directives
import {InputFormatDirectiveDirective} from './directive/input-format-directive.directive';
import {FilterPipe} from './pipes/filter-pipe';
import {NgxPaginationModule} from 'ngx-pagination';

//master service
import {MBulkGiftVoucherCustomerService} from './view/master-files/m-gift-voucher-bulk-customer/service/m-gift-voucher-customer.service';
import {MGiftvoucherPriceCategoryService} from './view/master-files/m-gift-voucher-price-category/service/m-gift-voucher-price-category.service';
import {MGiftVoucherService} from './view/master-files/m-gift-voucher/service/m-gift-voucher.service';
import {MBranchService} from './view/service/m-branch/service/m-branch.service';

//trasaction service
import {
  TGiftVoucherTransferService
} from './view/transactions/t-gift-voucher-transfer/service/t-gift-voucher-transfer.service';
import {NgxSmartModalModule} from 'ngx-smart-modal';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {MSupplierComponent} from './view/master-files/m-supplier/m-supplier.component';
import {MStoreComponent} from './view/master-files/m-store/m-store.component';
import {MStoreService} from './view/master-files/m-store/service/m-store.service';
import {MSupplierService} from './view/master-files/m-supplier/service/m-supplier.service';
import { TGrnComponent } from './view/transactions/t-grn/t-grn.component';
import {TGrnService} from './view/transactions/t-grn/service/t-grn.service';
import {MItemService} from './view/service/m-item/service/m-item.service';
import {TStockLedgerService} from './view/service/t-stock-ledger/service/t-stock-ledger.service';
import { InputFocusDirective } from './directive/input-focus.directive';
import { TStockTransferOutComponent } from './view/transactions/t-stock-transfer-out/t-stock-transfer-out.component';
import { TStockTransferInApproveComponent } from './view/transactions/t-stock-transfer-in-approve/t-stock-transfer-in-approve.component';
import {TStockTransferOutService} from './view/transactions/t-stock-transfer-out/service/t-stock-transfer-out.service';
import {NgxSpinnerModule} from 'ngx-spinner';
import { InputNextFocusDirective } from './directive/input-next-focus.directive';
import { TransactionSummaryDashboardComponent } from './view/dashboard/transaction-summary-dashboard/transaction-summary-dashboard.component';
import {TransactionSummaryDashboardService} from './view/dashboard/transaction-summary-dashboard/service/transaction-summary-dashboard.service';


@NgModule({
  declarations: [
    AppComponent,
    ContainerComponent,
    //directives
    InputFormatDirectiveDirective,
    FilterPipe,
    //common component
    HeaderComponent,
    FooterComponent,
    NavigationComponent,
    //master file componenet
    MGiftVoucherPriceCategoryComponent,
    MGiftVoucherComponent,
    MGiftVoucherBulkCustomerComponent,
    //trasaction componenet
    TGiftVoucherTransferComponent,
    MStoreComponent,
    MSupplierComponent,
    TGrnComponent,
    InputFocusDirective,
    TStockTransferOutComponent,
    TStockTransferInApproveComponent,
    InputNextFocusDirective,
    TransactionSummaryDashboardComponent
  ],
  imports: [
    BrowserModule,
    SnotifyModule,
    NgxPaginationModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxSpinnerModule,
    NgbModule.forRoot(),
    NgxSmartModalModule.forRoot()
  ],
  providers: [
    //common master files service
    MBranchService,
    //master files service
    MGiftvoucherPriceCategoryService,
    MBulkGiftVoucherCustomerService,
    MGiftVoucherService,
    MStoreService,
    MSupplierService,
    MItemService,
    //trasaction service
    TGiftVoucherTransferService,
    TGrnService,
    TStockLedgerService,
    TStockTransferOutService,
    //dashboard
    TransactionSummaryDashboardService,
    {
      provide: 'SnotifyToastConfig',
      useValue: ToastDefaults
    },
    SnotifyService],
  bootstrap: [AppComponent]
})

export class AppModule {
}

platformBrowserDynamic().bootstrapModule(AppModule).then(ref => {
  // Ensure Angular destroys itself on hot reloads.
  if (window['ngRef']) {
    window['ngRef'].destroy();
  }
  window['ngRef'] = ref;

  // Otherise, log the boot error
}).catch(err => console.error(err));



// WEBPACK FOOTER //
// ./src/app/app.module.ts